import logo from './logo.svg';
import './App.css';
import Button from '@mui/material/Button'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Pages/Home/home'

function App() {
  return (
    < >
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home />}>
            {/* <Route index element={<Home />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} /> */}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
